function accordion() {
    document.querySelectorAll('.rich-text-accordion').forEach(function(richAcc) {

        // no tab on all links as default
        var allLinks = richAcc.getElementsByTagName("a"); // Get all <a> tags inside the panel
        for (var l = 0; l < allLinks.length; l++) {
            allLinks[l].setAttribute('tabindex', '-1');
        }


        var acc = richAcc.getElementsByClassName("accordion-btn");
        var i;
        
        for (i = 0; i < acc.length; i++) {
            acc[0].style.maxHeight = acc[0].scrollHeight + 80 + "px";
            acc[i].addEventListener("click", function() {
            this.classList.toggle("active");
           
            var panel = this.nextElementSibling;
            var links = panel.getElementsByTagName("a"); // Get all <a> tags inside the panel



            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
                panel.style.paddingBottom = null;
                this.setAttribute('aria-expanded', 'false');

                 // Disable tabbing for links inside the closed panel
                 for (var j = 0; j < links.length; j++) {
                    links[j].setAttribute('tabindex', '-1');
                }
            } else {
                panel.style.maxHeight = panel.scrollHeight + 80 + "px";
                panel.style.paddingBottom = 80 + "px"
                this.setAttribute('aria-expanded', 'true');

                 // Enable tabbing for links inside the opened panel
                 for (var j = 0; j < links.length; j++) {
                    links[j].setAttribute('tabindex', '0');
                }
            } 
            });
        }
    })
}